import { Fade, Typography } from '@mui/material';
import ThumbUpSharp from '@mui/icons-material/ThumbUpSharp';
import * as React from 'react';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
  },
  iconWrapper: {
    color: 'white',
    backgroundColor: '#52bf52',
    borderRadius: '50%',
    width: 192,
    height: 192,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: { fontSize: 96, color: 'white' },
  text: { marginTop: '4vh' },
}));

export interface FormSuccessImageProps {
  text: string | React.ReactNode;
}

const FormSuccessImage: React.FC<FormSuccessImageProps> = ({ text }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Fade in timeout={800}>
        <div className={classes.iconWrapper}>
          <ThumbUpSharp className={classes.icon} />
        </div>
      </Fade>
      <Typography className={classes.text}>{text}</Typography>
    </div>
  );
};

export default FormSuccessImage;
